module.exports = __webpack_public_path__ + "img/Messaging_Platform_Integration_2.613e356a.png";